import { SurveyLanguageContext } from './SurveyLanguageContext';
import { SurveyLanguageControllerProps } from './SurveyLanguageController.types';

export const SurveyLanguageController = ({ language, children }: SurveyLanguageControllerProps) => {
  return <SurveyLanguageContext.Provider value={language}>{children}</SurveyLanguageContext.Provider>;
};
